import { httpClient } from "../http/httpClient";

export type SignatureLinkResponse = {
  url: string;
};

export async function getSignatureLink(
  preTransactionId: string,
): Promise<SignatureLinkResponse> {
  const { data } = await httpClient
    .get<SignatureLinkResponse>(`/crefaz-clt/${preTransactionId}/signature-link`)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
